import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./components/sidebar";
import { PageDataProvider } from "./core";
import { reInitMenu } from "../helpers";

const MasterLayout = () => {
  const location = useLocation();
  useEffect(() => {
    reInitMenu();
  }, [location.key]);

  return (
    <PageDataProvider>
      <div className={"flex w-full"}>
        <Sidebar />
        <Outlet />
      </div>
    </PageDataProvider>
  );
};

export { MasterLayout };
